import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  editorContainer: {
    margin: theme.spacing(0)
  },
  bodyText: {
    whiteSpace: 'pre-line'
  }
}));
